import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { t } from 'i18next';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export const CutsBlock = ({cutsUrl, onClick}: {cutsUrl: string, onClick: () => void}) => {
	return <Box display='flex' flexDirection='column' gap={1} mt={2}>
		<Typography variant='h5'>{t('planView.cuts')}</Typography>
		<div>
			<Button href={cutsUrl} target="_blank" variant='contained' color='secondary' onClick={onClick}>
				{t('planView.viewCuts')}
				<OpenInNewIcon fontSize='small' sx={{ml:1, mb: -0.5}} />
			</Button>
		</div>
	</Box>;
};